<template>
  <div>
    <h1 class="onboarding__title mb-5">
      Tudo certo,<br />
      agora é com a gente!
    </h1>
    <p class="mb-15">
      Registramos o seu interesse. Entraremos em contato o mais breve possível
      ou, se preferir, fale conosco pelo telefone
      <a
        href="https://api.whatsapp.com/send?phone=5548991610680"
        rel="noopener noreferrer"
        target="_blank"
      >
        +55 (48) 9 9161-0680
      </a>
      ou pelo e-mail
      <a href="mailto:comercial@hauseful.com">comercial@hauseful.com</a>.
    </p>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'OnboardingStepsRecurring',

  methods: {
    ...mapMutations(['setOnboardingStepsNavigation']),
  },
}
</script>
